import Home from '@/pages/Home/Home.vue'; // non-lazy loading
export default[{
  path: '/',
  name: 'home',
  component: Home,
}];
